import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {VoteValue} from '../../enums/vote-value.enum';
import {ContactInfo} from '../../store/contact/contact.model';
import {PortalInfo} from '../../store/portal/portal.model';
import {getActualLanguage} from '../../functions/translate-utils';
import {isUrlSafeUsername} from '../../functions/utils';

enum ResponseType {
  BLOB = 'blob',
}

enum Observe {
  RESPONSE = 'response',
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  private http: HttpClient = inject(HttpClient);

  getContactData(username: string): Observable<ContactInfo> {
    const segment = encodeURIComponent(username);
    return this.http.get<ContactInfo>(
      `${environment.publicApiUrl}/login-page/${segment}?language=${getActualLanguage().toUpperCase()}`,
      {withCredentials: true},
    );
  }

  getPortalData(): Observable<PortalInfo> {
    return this.http.get<PortalInfo>(
      `${environment.portalApiUrl}/voting_portal/participation_law?language=${getActualLanguage().toUpperCase()}`,
      {withCredentials: true},
    );
  }

  requestLoginCode(username: string): Observable<object> {
    if (!isUrlSafeUsername(username)) {
      return EMPTY;
    }
    const segment = encodeURIComponent(username);
    return this.http.get(`${environment.publicApiUrl}/send-login-code/${segment}`, {withCredentials: true});
  }

  login({username, password}: {username: string, password: string}): Observable<object> {
    const data = new FormData();
    data.append('username', username);
    data.append('password', password);
    return this.http.post(
      `${environment.portalApiUrl}/login`,
      data,
      {withCredentials: true},
    );
  }

  makeVote(voteValue: VoteValue): Observable<object> {
    return this.http.post(`${environment.portalApiUrl}/voting_portal/vote`, {voteValue}, {withCredentials: true});
  }

  downloadDocument(documentId: string): Observable<object> {
    return this.http.get(`${environment.portalApiUrl}/voting_portal/download/${documentId}`, {
      responseType: ResponseType.BLOB,
      observe: Observe.RESPONSE,
      withCredentials: true,
    });
  }

  getSharedLinkById(id: string): Observable<object> {
    return this.http.get(`${environment.sngGatewayApiUrl}/shared-links/${id}`, {withCredentials: true});
  }

  getGuestToken(): Observable<object> {
    return this.http.get(environment.sharedLinkAuthApiUrl);
  }

  logout(): Observable<object> {
    return this.http.post(
      `${environment.portalApiUrl}/logout`,
      {},
      {withCredentials: true},
    );
  }

}
